export const clean_serial = (serial) => serial
    .replace(/[- ]/g, '')
    .replace(/[Oo]/g, '0')
    .replace(/[Оо]/g, '0')
    .replace(/[Ii]/g, '1')
    .replace(/[Аа]/g, 'A') // rus -> lat
    .replace(/[Вв]/g, 'B') // rus -> lat
    .replace(/[Сс]/g, 'C') // rus -> lat
    .replace(/[Дд]/g, 'D') // rus -> lat
    .replace(/[Ее]/g, 'E') // rus -> lat
    .replace(/[Фф]/g, 'F') // rus -> lat
    .toUpperCase();
export const check_serial_crc = (serial) => {
    // const bytes = [0, 1, 2, 3, 4, 5].map((i) =>
    //     parseInt(serial.slice(2*i, (2*i)+2), 16));
    const bytes = new Array(6);
    for (let i = 0; i < 6; i++)
        bytes[i] = parseInt(serial.substr(2 * i, 2), 16);
    let crc = 0;
    for (let b of bytes) {
        for (let j = 0; j < 8; j++) {
            if (((crc ^ b) & 0x01) === 0)
                crc >>= 1;
            else
                crc = ((crc ^ 0x18) >> 1) | 0x80;
            b >>= 1;
        }
    }
    return crc === 0;
};
